// src/components/GGSlider/GGSlider.js

import React from 'react';
import { styled } from '@mui/material/styles';
import Slider from '@mui/material/Slider';
import './mui_styles.css';


const StyledSlider = styled(Slider)(({ theme }) => ({
  color: '#16dfad',
  height: 10,
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#16dfad',
  },
  '& .MuiSlider-track': {
    backgroundColor: '#16dfad',
  },
  '& .MuiSlider-rail': {
    backgroundColor: '#16dfad',
  },
  '& .MuiSlider-markLabel': {
    fontSize: 16,
    
    marginTop: 4,
    lineHeight: 1.3,
    transform: 'translateX(-50%) translateY(4px)',
  },
    '& .MuiSlider-markLabelActive': {
    color: '#00BC7A', // color for selected or above
    
  }
  
}));



class MUI_Slider extends React.Component {
  constructor(props) {
    super(props);
    this.handleSliderChange = this.handleSliderChange.bind(this);
  }

  handleSliderChange(event, value) {
    this.props.onChange(value);
  }

  render() {
    return (
      <div className="mui_slider_wrapper" style={{ paddingBottom: '48px', paddingTop: '32px', width: '95%', "marginLeft":'2.5%' }}>

      <StyledSlider
          value={this.props.value}
          onChange={this.handleSliderChange}
          step={1}
          min={this.props.min}
          max={this.props.max}
          marks={this.props.marks}
          valueLabelDisplay={ "auto"}
          valueLabelFormat={(value) => `$${value}`}

        /></div>
    );
  }
}

export default MUI_Slider;